import { render } from "./Ios.vue?vue&type=template&id=5af33cd2"
import script from "./Ios.vue?vue&type=script&lang=js"
export * from "./Ios.vue?vue&type=script&lang=js"

import "./Ios.vue?vue&type=style&index=0&id=5af33cd2&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__